import React, { useEffect, useState } from "react";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import {
  AdvSeparator,
  Button,
  Drawer,
  DualIcon,
  InfoTextAdv,
  PageHeader,
  Modal,
  PageTitle,
  SmartTooltip,
  StatusTags,
  showToast,
  NewTab,
  LogoLoader,
  Backdrop,
  DocumentViewerATS,
  CopyToClipboard,
} from "../../../../components";
import Resume from "../InternalDBDetailTabs/Resume";
import PersonalDetails from "../InternalDBDetailTabs/PersonalDetails";
import JobApplied from "../../Applicants/Applicant/AllApplicantsViewTabs/JobApplied";
import Notes from "../../Applicants/Applicant/AllApplicantsViewTabs/Notes";
import WorkExperience from "../../Applicants/Applicant/AllApplicantsViewTabs/WorkExperience";
import EmailMerges from "../InternalDBDetailTabs/EmailMerges";
import Skills from "../../Applicants/Applicant/AllApplicantsViewTabs/Skills";
import EmailModal from "./DetailsModals/EmailModal";
import ApplicantNotesModal from "../../Applicants/Applicant/Modal/ApplicantDetailsModals/ApplicantNotesModal";
import ApplicantSubmitJobModal from "../../Applicants/Applicant/Modal/ApplicantDetailsModals/ApplicantSubmitJobModal";
import {
  addCandidateNotes,
  addEmailPost,
} from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import { Link } from "react-router-dom";
import { formatPhoneNumberLength, formatWords2 } from "../../../../utils/stringUtils";
import { addNoteToApplicant, updateAllSourceNotes } from "../../../../redux/slices/internalDbES/internalDbESlice";
import { useDispatch, useSelector } from "react-redux";
import { getApplicant } from "../../../../redux/slices/recruitmentSourcing/SourcingApi";
import { hasContent, isFileTypeMissingFromUrl } from "../../../../utils/common";
import axiosRequest from "../../../../redux/slices/universal/axiosService";

const DetailsDrawer = ({
  loading,
  isOpen,
  onClose,
  source,
  keywords,
  searchQuery,
  candidate,
  getCurrentApplicantPersonalDetails,
  getCurrentApplicantJobTitle,
  getCurrentApplicantContactDetailsForHeader,
}) => {
  const { user } = useSelector((state) => state?.auth);
  const dispatch = useDispatch();;
  const applicantData = getCurrentApplicantContactDetailsForHeader();
  const [internalDBdata, setInternalDBData] = useState(null);
  const candidateEmail =
    candidate()?.email?.primary?.email;
  const data = {
    Mobile:
      formatPhoneNumberLength("+1", applicantData?.mobile?.primary?.number) || formatPhoneNumberLength("+1", applicantData?.Mobile) || "—",
    "Job Title": applicantData?.["Job Title"] || "—",
    Location: applicantData?.Location || "—",
    "Work Authorization":
      applicantData?.["Work Authorization"] ||
      applicantData?.["Work Authorizationn"] ||
      "—",
    "Experience (Years)": applicantData?.["Experience(Years)"] || "—",

    Email:
      applicantData?.Email?.email ||
      candidateEmail ||
      applicantData?.Email ||
      "—",
  };
  // console.log(candidate())
  const [emailModal, setEmailModal] = useState(false);
  const [notesModal, setNotesModal] = useState(false);
  const [submitJobModal, setSubmitJobModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [awsUrl, setAwsUrl] = useState("");
  const [awsHtmlResume, setAwsHtmlResume] = useState("");
  const [notes, setCandidateNotes] = useState("");
  const [notesRefreshKey, setNotesRefreshKey] = useState(0);
  const [awsurlloading, setawsurlLoading] = useState(false);
  const [emailFormData, setEmailFormData] = useState({
    emailSource: "",
    emailAccount: "",
    datePicker: "",
    template: "",
    subject: "",
    emailText: "",
  });
  const handleEmailChange = (key, value) => {
    setEmailFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleCloseEmailModal = () => {
    setEmailFormData({
      emailText: "",
    });
    setEmailModal(false);
  };


  const searchDetailMenus = [
    {
      title: "Resume",
      page: (
        <Resume
          isOpen={isOpen}
          candidate={internalDBdata ? internalDBdata : candidate()}
          source={source}
          searchQuery={searchQuery}
          keywords={keywords()}
          onClose={onClose}
          loading={loading}
        />
      ),
      type: "main",
    },

    {
      title: "Personal Details",
      page: (
        <PersonalDetails
          currentApplicantPersonalDetails={getCurrentApplicantPersonalDetails()}
        />
      ),
      type: "main",
    },
    {
      title: "Job Applied",
      page: <JobApplied data={candidate()}/>,
      type: "main",
    },
    {
      title: "Notes",
      page: (
        <Notes applicantId={candidate()?.uiid} refreshKey={notesRefreshKey} source={source} openNotesModal={() => setNotesModal(true)} />
      ),
      type: "main",
    },
    {
      title: "Skills",
      page: <Skills applicant={candidate()} />,
      type: "main",
    },
    {
      title: "Work Experience",
      page: <WorkExperience applicant={candidate()} />,
      type: "main",
    },
    {
      title: "Email Merges",
      page: <EmailMerges />,
      type: "main",
    },
  ];

  const fetchApplicant = async () => {
    if (!isOpen) return;
    if (!candidate()?.uiid) {
      setInternalDBData(null);
      return;
    }
    try {
      let res = await getApplicant({
        fil: JSON.stringify({
          uiid: { type: "NONE", value: candidate()?.uiid },
        }),
        coll: "Candidate",
        ref: "Resume",
        extret: "uiid firstName",
      });

      if (res?.data?.data) {
        setInternalDBData(res?.data?.data);
      } else {
        //showToast("No applicant details found", "warning");
      }
    } catch (err) {
      console.error(err);
      showToast("Failed to fetch applicant details", "error");
    }
  };
  useEffect(() => {
    if (source == 1) {
      fetchApplicant();
    }
  }, [isOpen]);

  const resumeData = source == 1 ? internalDBdata : candidate();
  // const resumeLink = applicantData?.resumes?.[0]?.files?.[0]?.key ?? "";
  const resumeLink = resumeData?.resumes?.at(-1)?.files?.at(-1)?.key ?? "";
  const resumeName =
    `${resumeData?.firstName} ${resumeData?.middleName} ${resumeData?.lastName}` ??
    "resume";
  const resumePathName =
    resumeData?.resumes?.at(-1)?.files?.at(-1)?.name ?? "Resume.docx";
  const resumeId = resumeData?.resumeIds?.[0] ?? "";

  //  console.log(keywords() )

  function extractS3Key(url) {
    return url.replace(/^https?:\/\/[^/]+\//, "");
  }

  const getCandidateResume = async () => {
    const fileExtension = resumePathName?.split(".").pop();
    const query = new URLSearchParams({
      key: extractS3Key(resumeLink),
      fileName: `${resumeName}.${fileExtension}`,
      coll: "Candidate",
    }).toString();

    const url = `${ENDPOINTS.CANDIDATES.RESUME_URL}?${query}`;
    try {
      const response = await axiosRequest({ method: "GET", url })
      if (!response.success) {
        return showToast("Not Downloaded", "error");
      }
      const data = response?.data?.data?.url || "";
      if (data) {
        const fileFormateWorng = await isFileTypeMissingFromUrl(data);
        if (fileFormateWorng) {
          showToast("File format is not supported", "warning");
          return;
        }
      }
      handleDownloadResume(response?.data?.data?.url);
    } catch (err) {
      console.error("Error fetching data:", err);
      showToast("Not Downloaded", "error");
    }
  };

  const viewResume = async () => {
    const query = new URLSearchParams({
      key: extractS3Key(resumeLink),
      // fileName: resumePathName,
      coll: "Candidate",
      html: true
    }).toString();

    const url = `${ENDPOINTS.CANDIDATES.RESUME_URL}?${query}`;
    setawsurlLoading(true);
    try {
      setAwsHtmlResume("")
      const response = await axiosRequest({ method: "GET", url })
      if (response?.success) {
        const s3Key = response?.data?.data?.url || "";
        setAwsUrl(s3Key);
        setAwsHtmlResume(response?.data?.data?.htmlContent || "");
        setawsurlLoading(false);
      } else {
        setawsurlLoading(false);
      }
    } catch (err) {
    } finally {
      setawsurlLoading(false);
    }
  };

  const handleDownloadResume = async (response) => {
    try {
      // ---------- REPLACE FROM HERE ----------
      // if response is a URL string, just open it directly for download
      if (typeof response === "string" && response.startsWith("http")) {
        const link = document.createElement("a");
        link.href = response;
        // optional: set filename — browsers often ignore cross-origin downloads for filename
        link.download = resumeName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        showToast("Download Successfull", "success", 2000);
        return; // done
      }
      // ---------- TO HERE ----------

      // existing fallback for Blobs/ArrayBuffers (leave as-is)
      let blob = response;
      if (response instanceof ArrayBuffer) blob = new Blob([response]);
      //console.log(blob);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = resumeName || "resume.docx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
      showToast("Download Successful.", "success", 2000);
    } catch (error) {
      showToast("Download Unsuccessful.", "error", 2000);
      console.error(
        "Error triggering download:",
        error && error.message ? error.message : error,
      );
    }
  };

  const handleAddNotes = async (jobPost, priority) => {
    if (!notes?.trim()) {
      showToast("Please Enter Notes", "error", 2000);
      return;
    }
    try {
      const res = await addCandidateNotes({
        coll: "Note",
        postActions: ["updateSource"],
        payload: {
          addedBy: user?.data?.uiid,
          candidateId: resumeData?.uiid,
          note: notes,
          source: 2,
          ...(jobPost != null && { jobPostId: jobPost }),
          ...(priority != null && { priority }),
        },
      });
      if (res?.data) {
        setNotesModal(false);
        showToast("Notes Added Successfully", "success", 2000);
        setCandidateNotes("");
        const data = res?.data?.data || {};
        dispatch(
          updateAllSourceNotes({
            applicantId: data.candidateId,
            newNoteUiid: data.uiid,
             uiid: data?.uiid,
            note: data?.note,
            addedBy: data?.addedBy,
            addedOn: data?.addedOn
          }),
        );
        dispatch(
          addNoteToApplicant({
            applicantId: data?.candidateId,
            uiid: data?.uiid,
            note: data?.note,
            addedBy: data?.addedBy,
            addedOn: data?.addedOn
          })
        );
        setNotesRefreshKey((prev) => prev + 1);
      }
    } catch (error) {
      showToast("Error Adding Notes", "error", 2000);
      console.error("Error adding notes:", error);
    } finally {
    }
  };

  const handleSendEmail = async () => {
    try {
      const res = await addEmailPost({
        coll: "CandidateEmailLog",

        payload: {
          addedBy: user?.data?.uiid ?? "",
          candidateId: resumeData?.uiid ?? "",
          email: "",
          version: 1,
          type: 1,
          lastHistoryStatus: 1,
          historyLogs: [
            {
              addedBy: user?.data?.uiid,
              from: "",
              integrationAccessId: "",
              jobPostId: "",
              templateId: "",
              source: "",
              typeOfEmail: "",
              status: "",
              error: { code: "", message: "" },
            },
          ],
        },
      });
      if (res?.data) {
        setEmailModal(false);
        setCandidateNotes("");
      }
    } catch (error) {
      console.error("Error adding notes:", error);
    } finally {
    }
  };
  //console.log(getCurrentApplicantContactDetailsForHeader())
  const htmlFormat =
    source === 1
      ? candidate()?.htmlResume || "Resume not available"
      : candidate()?.resumes?.at(-1)?.files?.at(-1)?.html ||
      "Resume not available";
  return (
    <div>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        width="xl:w-2xl 2xl:w-5xl md:w-3xl"
        title="  "
      >
        <div className="shadow-md !bg-[#fffcfa] rounded-lg p-3 mx-3 my-1">
          <PageHeader
            Section={
              <div className="flex items-center gap-4">
                <div className="flex flex-col items-start">
                  <div className="text-primary mb-0.5">
                    {candidate()?.uiid ? (
                      <Link
                        to="/ats/applicants/applicant-details"
                        state={{
                          applicantId: candidate()?.uiid,
                        }}
                        className="cursor-pointer"
                      >
                        <PageTitle
                          title={formatWords2(
                            getCurrentApplicantPersonalDetails()?.["Name"] ??
                            `${getCurrentApplicantPersonalDetails()?.["First Name"] || ""} ${getCurrentApplicantPersonalDetails()?.["Last Name"] || ""}`.trim(),
                          )}
                          tag="h6"
                        />
                      </Link>
                    ) : (
                      <PageTitle
                        title={formatWords2(
                          getCurrentApplicantPersonalDetails()?.["Name"] ??
                          `${getCurrentApplicantPersonalDetails()?.["First Name"] || ""} ${getCurrentApplicantPersonalDetails()?.["Last Name"] || ""}`.trim(),
                        )}
                        tag="h6"
                      />
                    )}
                  </div>
                  <div className="text-gray-400 font-[500] text-xs">
                    <PageTitle
                      title={
                        //"New Role"
                        formatWords2(getCurrentApplicantJobTitle())
                      }
                      tag="p"
                    />
                  </div>
                </div>
                {candidate()?.uiid && <StatusTags icon />}
              </div>
            }
            RightSection={
              <div className="flex item-center gap-3">
                <SmartTooltip
                  description={"Call"}
                  tooltipPosition={"bottom"}
                  to={"/ats/applicants/viewresume"}
                  noicon
                >
                  <Button
                    color="black"
                    type="icon"
                    disabled={
                      resumeData?.resumes || resumeData?.htmlResume ? false : true
                    }
                    icon={"phone"}
                    variant="text"
                    size="sm"
                  />
                </SmartTooltip>
                <SmartTooltip
                  description={"Download"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  <Button
                    color="black"
                    type="icon"
                    disabled={
                      resumeLink || resumeData?.htmlResume ? false : true
                    }
                    onClick={getCandidateResume}
                    icon={"vertical_align_bottom"}
                    variant="text"
                    size="sm"
                  />
                </SmartTooltip>
                {/* <SmartTooltip
                  description={"Open New Tab"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  <Button
                    color="black"
                    type="icon"
                    //onClick={openResumeNewPage}
                    icon={"open_in_new"}
                    variant="text"
                    size="sm"
                  />
                </SmartTooltip> */}
                <Link
                  to={`/resumeviewerapplicant/${candidate()?.uiid ?? ""}?keywords=${encodeURIComponent(JSON.stringify(keywords() ?? []))}`}
                  target="_blank"
                  // onClick={() => {
                  //   localStorage.setItem(
                  //     "applicantId",
                  //     JSON.stringify(candidate()?.uiid ?? ""),
                  //   );
                  //   localStorage.setItem(
                  //     "keywords",
                  //     JSON.stringify(keywords() ?? []),
                  //   );
                  // }}
                  rel="noopener noreferrer"
                  className="text-info-400 flex items-center gap-.5"
                >
                  {" "}
                  <SmartTooltip
                    description={"Open New Tab"}
                    tooltipPosition={"bottom"}
                    noicon
                  >
                    <Button
                      color="black"
                      type="icon"
                      disabled={
                        resumeData?.resumes || resumeData?.htmlResume ? false : true
                      }
                      icon={"open_in_new"}
                      variant="text"
                      size="sm"
                    />
                  </SmartTooltip>
                </Link>

                {/* <Link
                  to="/resumeviewer"
                  target="_blank"
                  onClick={() => {
                    const dataToStore = {
                      loading,
                      isOpen,
                      source,
                      keywords: keywords(),
                      searchQuery,
                      candidate: candidate(),
                      currentApplicantPersonalDetails:
                        getCurrentApplicantPersonalDetails(),
                      currentApplicantJobTitle: getCurrentApplicantJobTitle(),
                      currentApplicantContactDetailsForHeader:
                        getCurrentApplicantContactDetailsForHeader(),
                    };

                    // Save in localStorage
                    localStorage.setItem(
                      "applicantData",
                      JSON.stringify(dataToStore)
                    );
                    localStorage.setItem("resumeId", JSON.stringify(resumeId));
                  }}
                  rel="noopener noreferrer"
                  className="text-info-400 flex items-center gap-.5"
                >
                  
                  <SmartTooltip
                    description={"Open New Tab"}
                    tooltipPosition={"bottom"}
                    noicon
                  >
                    <Button
                      color="black"
                      type="icon"
                      disabled={
                        resumeLink || resumeData?.htmlResume ? false : true
                      }
                      icon={"open_in_new"}
                      variant="text"
                      size="sm"
                    />
                  </SmartTooltip>
                </Link> */}

                <SmartTooltip
                  description={"View Resume"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  <Button
                    color="black"
                    type="icon"
                    disabled={
                      resumeLink || resumeData?.htmlResume ? false : true
                    }
                    icon={"visibility"}
                    onClick={async () => {
                      setViewModal(true);
                      await viewResume(); // optional await if you want to ensure it completes before something else later
                    }}
                    variant="text"
                    size="sm"
                  />
                </SmartTooltip>

                <SmartTooltip
                  description={"Email"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  <Button
                    color="black"
                    type="icon"
                    icon={"mail"}
                    disabled={
                      resumeData?.resumes || resumeData?.htmlResume ? false : true
                    }
                    variant="text"
                    size="sm"
                    onClick={() => setEmailModal(true)}
                  />
                </SmartTooltip>
                <SmartTooltip
                  description={"Note"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  {(resumeData?.resumes || resumeData?.htmlResume) && (
                    <DualIcon
                      iconColor={"black"}
                      badgeIconColor="bg-black"
                      size="xs"
                      onClick={() => setNotesModal(true)}
                    />
                  )}
                </SmartTooltip>
                <SmartTooltip
                  description={"Submit Job"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  {(resumeData?.resumes || resumeData?.htmlResume) && (
                    <DualIcon
                      size="xs"
                      icon="article"
                      badgeIcon="visibility"
                      iconColor="black"
                      dotPosition="bottom-right"
                      badgeIconColor="text-black"
                      onClick={() => setSubmitJobModal(true)}
                    />
                  )}
                </SmartTooltip>
              </div>
            }
          // RightSection={Array.from({ length: 11 }, (_, i) => (
          //   <span className="material-symbols-outlined mr-3">
          //     vertical_align_bottom
          //   </span>
          // ))}
          />

          <div className="px-8 inner-section shadow-xl rounded-lg py-5 flex my-3">
            <div className="flex flex-1 w-full">
              <AdvSeparator gap="gap-6" className="gap-y-6 overflow-hidden">
                {Object.keys(
                  data,
                  //getCurrentApplicantContactDetailsForHeader()
                ).map((key, index) => {
                  return (
                    <>
                      <InfoTextAdv
                        key={index}
                        title={key}
                        titleProps={{ className: "!text-black" }}
                        value={
                          <div className="w-full">
                            <div className=" text-black font-medium">
                              {key === "Email" ? (
                                <div className={"flex items-center gap-0.5 "}>
                                  <h6 className="line-clamp-1">
                                    {
                                      //getCurrentApplicantContactDetailsForHeader()?.Email?.email
                                      data[key]
                                    }
                                  </h6>
                                  <CopyToClipboard
                                    content={
                                      //getCurrentApplicantContactDetailsForHeader()?.[key]
                                      data[key]
                                    }
                                    title={data[key]}
                                  />
                                </div>
                              ) : (
                                // <h6 className="line-clamp-1">
                                //   {
                                //     //getCurrentApplicantContactDetailsForHeader()?.[key]
                                //     data[key]
                                //   }
                                // </h6>
                                <h6
  className={
    key === "Mobile"
      ? "whitespace-nowrap overflow-hidden text-ellipsis"
      : "line-clamp-1"
  }
>
  {data[key]}
</h6>
                              )}
                            </div>
                          </div>
                        }
                      />
                    </>
                  );
                })}
              </AdvSeparator>
            </div>
          </div>
        </div>
        <div className="flex-1 flex flex-col h-full">
          <NewTab
            tabs={searchDetailMenus}
            color="gray"
            variant="text"
            activeVariant="text"
          />
        </div>
      </Drawer>
      <EmailModal
        isOpen={emailModal}
        onClose={handleCloseEmailModal}
        onSend={handleSendEmail}
        formData={emailFormData}
        onChange={handleEmailChange}
        candidateEmail={resumeData?.email?.email ?? resumeData?.email ?? ""}
      />

      <ApplicantNotesModal
        value={notes}
        onChange={(e) => {
          const val = e?.target?.value ?? e;
          setCandidateNotes(val);
        }}
        onClick={async (jobPost, priority) => {
          await handleAddNotes(jobPost, priority);
        }}
        isOpen={notesModal}
        onClose={() => {
          setNotesModal(false);
          setCandidateNotes("");
        }}
      />
      <ApplicantSubmitJobModal
        isOpen={submitJobModal}
        onClose={() => setSubmitJobModal(false)}
        applicant={resumeData}
      />
      <Modal
        width="max-w-6xl"
        title={formatWords2(resumeName || "Resume Details")}
        isOpen={viewModal}
        onClose={() => {
          setViewModal(false);
          setAwsUrl("");
          setAwsHtmlResume("")
        }}
      >
        <DocumentViewerATS
          AwsResumeUrl={awsUrl || ""}
          urlLoading={awsurlloading}
          htmlFormat={hasContent(awsHtmlResume) ? awsHtmlResume : htmlFormat}
        />
      </Modal>
      <Backdrop isOpen={loading} zIndex={51}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default DetailsDrawer;
